function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.5,0h0C5.6,0,0,5.6,0,12.5h0c0,6.9,5.6,12.5,12.5,12.5h0c6.9,0,12.5-5.6,12.5-12.5h0C25,5.6,19.4,0,12.5,0Zm-3.09,18.16c0,.07-.05.12-.12.12h-2.44c-.07,0-.12-.05-.12-.12v-7.81c0-.07.05-.12.12-.12h2.44c.07,0,.12.05.12.12v7.81Zm-1.34-9c-.89,0-1.61-.72-1.61-1.61s.72-1.61,1.61-1.61,1.61.72,1.61,1.61-.72,1.61-1.61,1.61Zm10.46,8.59c0,.3-.24.54-.54.54h-1.61c-.3,0-.54-.24-.54-.54v-3.76c0-.74-.6-1.34-1.34-1.34s-1.34.6-1.34,1.34v3.76c0,.3-.24.54-.54.54h-1.61c-.3,0-.54-.24-.54-.54v-6.98c0-.3.24-.54.54-.54h1.61c.3,0,.54.24.54.54v.34c.54-.69,1.42-1.15,2.41-1.15,1.48,0,2.95,1.07,2.95,3.22v4.56Z"
});

var SvgEroskiFooter3Linkedin = function SvgEroskiFooter3Linkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "linkedin",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter3Linkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer3-linkedin.d6de0df3.svg";
export { ForwardRef as ReactComponent };